// =====================================================================
//  ADSTERRA CODES — paste each raw Adsterra snippet between the backticks.
//  Leave a slot as `` (empty) and a dashed placeholder box is shown instead.
//  Ads are shown to FREE users only. Premium users never load any ad code.
// =====================================================================

const banner = (key, width, height) => key ? `<script>
  atOptions = { 'key' : '${key}', 'format' : 'iframe', 'height' : ${height}, 'width' : ${width}, 'params' : {} };
</script>
<script src="https://brijmohan.org/22/${key}"></script>` : ``;

export const ADSTERRA = {
  // Global scripts — loaded once for the whole site (free users).
  popunder: `<script data-cfasync="false" src="https://ahuramazda.org/1/3d489d3b3c037988f7b5ee427d710a97"></script>`,
  socialBar: `<script data-cfasync="false" src="https://brijmohan.org/14/e80b80977f64d49fee487a1217819a18"></script>`,

  // Popunder / redirect frequency cap: minutes of ad-free browsing after each redirect.
  popunderCooldownMin: 5,

  // Optional: a dedicated code fired when the 50-message lock opens.
  // Leave empty to re-fire the Popunder + Social Bar above instead.
  lockAd: ``,

  // Native Banner (shown inside the chat stream after every 10th message).
  native: `<script async="async" data-cfasync="false" src="https://brijmohan.org/21/450002c58ae88ab2c05e89f503e90f98"></script>
<div id="container-450002c58ae88ab2c05e89f503e90f98"></div>`,
  nativeHeight: 260,

  // Display banners. 728x90 + 320x50 keys come from frontend .env (REACT_APP_ADSTERRA_KEY_*).
  banners: {
    "728x90": banner(process.env.REACT_APP_ADSTERRA_KEY_728X90, 728, 90),
    "468x60": banner("9f32405004f4cbc0974b444702e1784b", 468, 60),
    "320x50": banner(process.env.REACT_APP_ADSTERRA_KEY_320X50, 320, 50),
    "300x250": banner("0e99d0cedff549cd9a4c8fd02cb98910", 300, 250),
  },
};
